__turbopack_context__.v({
  "buttons": "ModalFooter-module__V5B9ha__buttons",
  "dark": "ModalFooter-module__V5B9ha__dark",
  "footer": "ModalFooter-module__V5B9ha__footer",
  "hasBothSides": "ModalFooter-module__V5B9ha__hasBothSides",
  "hasOnlyLeftButton": "ModalFooter-module__V5B9ha__hasOnlyLeftButton",
  "hasOnlyRightButton": "ModalFooter-module__V5B9ha__hasOnlyRightButton",
  "primaryButton": "ModalFooter-module__V5B9ha__primaryButton",
  "secondaryButton": "ModalFooter-module__V5B9ha__secondaryButton",
});
